const breakdowns = {
  appNames: "appNames",
  useCountry: "country",
  day: "date",
  tag: "adUnit",
};

const quickDateButtons = [
  { range: "Y", text: "last day" },
  { range: "T", text: "today" },
  { range: "7D", text: "last 7 days" },
  { range: "30D", text: "last 30 days" },
  { range: "90D", text: "last 90 days" },
  { range: "MTD", text: "this month" },
  { range: "LM", text: "last month" },
  { range: "L3M", text: "last 3 months" },
  { range: "L6M", text: "last 6 months" },
];

const platforms = ["all", "iOS", "Android"];

export { breakdowns, quickDateButtons, platforms };
